export default __webpack_public_path__ + "static/media/21441_KS2_WX1_USA_Lanker-1_3_T-1_2018b.65ff20bb.gif";